<template>
    <ValidationProvider
        :name="name"
        :rules="rules"
        v-slot="{ errors }"
        :class="classWrapper"
        class="custom-wrapper"
        tag="div"
    >
        <div v-if="showTooltip" class="custom-info">
            <img class="ico" src="@/assets/images/info-icon.svg" alt="info" @click="toggleShowTooltip" />
            <div
                v-if="isShowTooltip"
                class="custom-tooltip"
                v-click-outside="closeTooltip"
            >
                <div class="custom-tooltip__title">{{ tooltipTitle }}</div>
                <div class="custom-tooltip__desc">
                    {{ tooltipDesc }}
                </div>
                <i
                    class="fa fa-times-circle custom-tooltip__close"
                    aria-hidden="true"
                    @click="closeTooltip"
                ></i>
            </div>
        </div>
        <div
            class="custom-form-control"
            :class="[isFocus && 'focus', disabled && 'disabled']"
        >
            <input
                :value="value"
                @input="onInput"
                @focus="onFocus"
                @blur="onBlur"
                :id="name"
                placeholder=""
                :disabled="disabled"
                :readonly="readonly"
            />
            <label :for="name">{{ label }}</label>
            <div class="custom-form-control__append-icon">
                <slot name="append-icon" />
            </div>
            <DatePicker
                v-if="!disabled && !readonly"
                class="c-custom-datepicker"
                v-model="date"
                value-type="format"
                format="MM/DD/YYYY"
                lang="en"
            />
        </div>
        <span class="custom-error">{{ errors[0] }}</span>
    </ValidationProvider>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    name: 'DatePickerField',
    components: {
        DatePicker,
    },
    data() {
        return {
            isFocus: false,
            isShowTooltip: false,
            date: null,
        };
    },
    props: {
        label: String,
        value: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        rules: [String, Array, Object],
        classWrapper: String,
        disabled: Boolean,
        readonly: Boolean,
        showTooltip: Boolean,
        tooltipTitle: String,
        tooltipDesc: String,
    },
    methods: {
        onInput(event) {
            this.$emit('input', event.target.value);
        },
        onFocus(event) {
            this.isFocus = true;
            this.$emit('focus', event.target.value);
        },
        onBlur(event) {
            this.isFocus = false;
            this.$emit('focus', event.target.value);
        },
        toggleShowTooltip() {
            this.isShowTooltip = !this.isShowTooltip;
        },
        closeTooltip() {
            this.isShowTooltip = false;
        },
    },
    watch: {
        date(value) {
            if (value) {
                this.$emit('input', value);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.custom-wrapper {
    min-height: 90px;
    display: flex;
    flex-wrap: wrap;
}
.custom-form-control {
    background-color: #e1e7e9;
    padding: 24px 16px 8px 16px;
    border-radius: 12px;
    position: relative;
    height: 59px;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    flex-grow: 1;

    &.focus {
        background-color: #e1e7e9;
    }

    &.disabled {
        opacity: 0.4;
    }

    label {
        color: #969fa2;
        font-size: 14px;
        position: absolute;
        margin-bottom: 0;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
        padding: 16px;
        transition: all 0.1s ease-in-out;
        cursor: text;
        display: flex;
        align-items: center;
    }

    input {
        border: none;
        background: none;
        font-size: 18px;
        color: rgba(51, 48, 60, 0.68);
        padding: 0;
        width: 100%;

        &::placeholder {
            visibility: hidden;
        }

        &:focus + label,
        &:not(:placeholder-shown) + label {
            font-size: 10px;
            opacity: 0.7;
            padding-block: 0;
            bottom: 24px;
            color: #1b659e;
        }
    }

    &__append-icon {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        right: 15px;
        z-index: 3;
        display: inline-block;
    }
}

.custom-error {
    color: var(--danger);
    font-size: 12px;
}
.custom-info {
    position: relative;
    .ico {
        color: #7bbdef;
        font-size: 20px;
        cursor: pointer;
        margin-right: 8px;
        margin-top: 20px;
    }
}
.custom-tooltip {
    position: absolute;
    border-radius: 30px;
    background: #edf5f7;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    min-width: 400px;
    padding: 20px;
    z-index: 10;
    transform: translate(30px, -60px);

    &__title {
        font-size: 16px;
        font-weight: 600;
        line-height: 24px; /* 150% */
        color: #41b8dc;
        margin-bottom: 8px;
    }

    &__desc {
        font-size: 16px;
        line-height: 24px; /* 150% */
        color: #7c7c7a;
    }

    &__close {
        position: absolute;
        right: 16px;
        top: 8px;
        color: #2178ab !important;
        cursor: pointer;
    }
}
</style>
<style lang="scss">
.c-custom-datepicker {
    z-index: 2;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    width: 100% !important;
    opacity: 0;
    .mx-input-wrapper {
        height: 100% !important;
        input {
            height: 100% !important;
        }
    }
}
</style>
